<template>
    <div>
        <pTitle></pTitle>
        <div class="GameContent">
            <div class="sports_title">
                <p>{{msg}}</p>
            </div>
            <div class="content_c">
                <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
                    <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
                    <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
                    <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
                </el-tabs> -->
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" 
                    text-color="#3641C9"
                    active-text-color="#3641C9"
                >
                    <el-menu-item v-for="(i,index) in NaList.nav" :key="index" :index="i.Route_Name"
                    :style="{'font-size':'24px','font-weight':'bold'}"
                    >
                        {{i.CHN_Name}}
                    </el-menu-item>
                    <!-- <el-menu-item index="2">处理2中心</el-menu-item> -->
                    <!-- <el-submenu index="2">
                        <template slot="title">我的工作台</template>
                        <el-menu-item index="2-1">选项1</el-menu-item>
                        <el-menu-item index="2-2">选项2</el-menu-item>
                        <el-menu-item index="2-3">选项3</el-menu-item>
                        <el-submenu index="2-4">
                        <template slot="title">选项4</template>
                        <el-menu-item index="2-4-1">选项1</el-menu-item>
                        <el-menu-item index="2-4-2">选项2</el-menu-item>
                        <el-menu-item index="2-4-3">选项3</el-menu-item>
                        </el-submenu>
                    </el-submenu> -->
                    <!-- <el-menu-item index="3" >消息中心</el-menu-item>
                    <el-menu-item index="4">订单管理</el-menu-item> -->
                </el-menu>


                <div>
                    <router-view></router-view>
                </div>


            </div>



        </div>

    </div>
</template>

<script>
import pTitle from "@/components/pTitle.vue";
import NaList from '@/assets/common/nav.json';
export default {
    components: {
        pTitle,
    },
    data() {
        return {
            msg: "PC端2024羽毛球成绩网站",
            activeName: 'second',
            activeIndex: 'GameResult',
            NaList: NaList,
            index:  0
        }
    },
    mounted() {
        console.log(this.$route)
        if(this.$route.path == '/Games/Results'){
            this.activeIndex = 'GameResult';
        }else if(this.$route.path == '/Games/PPool'){
            this.activeIndex = 'Pool';
        }else if(this.$route.path == '/Games/PBrackets'){
            this.activeIndex = 'Brackets';
        }else if(this.$route.path == '/Games/PRank'){
            this.activeIndex = 'Rank';
        }else if(this.$route.path == '/Games/PFiles'){
            this.activeIndex = 'Files';
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        //点击导航的选项
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            if(key  == "GameResult"){
                this.$router.push({
                    path: '/Games/Results', 
                    query: { v: randomNum }
                });
            }else if(key  == "Pool"){
                this.$router.push({
                    path: '/Games/PPool', 
                    query: { v: randomNum }
                });
            }else if(key  == "Brackets"){
                this.$router.push({
                    path: '/Games/PBrackets', 
                    query: { v: randomNum }
                });
            }else if(key  == "Rank"){
                this.$router.push({
                    path: '/Games/PRank', 
                    query: { v: randomNum }
                });
            }else if(key  == "Files"){
                this.$router.push({
                    path: '/Games/PFiles', 
                    query: { v: randomNum }
                });
            }
        }
    },
}
</script>

<style lang="scss" scoped>
 $color: #3641C9;
    ::v-deep .el-menu{
        background: none;
        // font-size: 36px;
        display: flex;
        justify-content: space-around;
    }
    ::v-deep .el-menu.el-menu--horizontal{
        border-bottom: solid 1px $color;
    }
    .GameContent{
        width: 1400px;
        background: rgba(255,255,255,0.8);
        margin: 10px auto;
        border-radius: 10px;
        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);
    }
    .sports_title{
        // width: 100%;
        text-align: center;
        padding: 10px;
        border-bottom: 1px solid $color;
        font-size: 30px;
        color: $color;
        font-weight: bold;
    }
    .content_c{
        padding: 10px;
    }
</style>